import {
  Dialog,
  DialogContent,
  DialogClose,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/common/Dialog";
import { ReactNode, useState } from "react";
import data from "@/public/data/flight/passengers.json";
import Typography from "@/shared/components/common/Typography";
import Flex from "@/shared/components/common/Flex";
import Input from "@/shared/components/common/input/Input";

interface RecentPassengersProps {
  children: ReactNode;
  passengers: RecentPassenger[];
  onSelect: (passenger: RecentPassenger) => void;
}

export default function RecentPassengersMobile({
  children,
  passengers,
  onSelect,
}: RecentPassengersProps) {
  const [searchValue, setSearchValue] = useState("");

  const {
    forms: {
      passengersForm: {
        recentPassegners: {
          dialog: { title, search, noPassenger, passengersMapList },
        },
      },
    },
  } = data;

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="z-100000! max-h-[82dvh] overflow-y-auto sm:max-w-[600px] max-sm:w-[calc(100vw-2rem)] max-sm:p-4">
        <DialogTitle className="self-center text-center">
          <Typography variant="h5" className="text-foreground font-normal">
            {title}
          </Typography>
        </DialogTitle>

        <Flex className="flex-col">
          <Input
            placeholder={search.placeHolder}
            type={search.type}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            className="rounded-xs"
          />
          <Flex className="py-4 justify-center">
            {passengers && passengers.length > 0 ? (
              <Flex className="w-full max-h-[52dvh] flex-col p-3 py-4 gap-y-3 overflow-y-auto">
                {passengers
                  .filter(
                    ({ firstname, lastname, identifier }) =>
                      firstname
                        .toLowerCase()
                        .includes(searchValue.toLowerCase()) ||
                      lastname
                        .toLowerCase()
                        .includes(searchValue.toLowerCase()) ||
                      identifier.toLowerCase(),
                  )
                  .map(({ firstname, identifier }, x) => (
                    <DialogClose key={`${firstname}-${identifier}-${x}`}>
                      <Flex
                        className="w-full h-auto flex-col rounded-xs border border-border p-3 py-4 gap-y-3 bg-muted"
                        key={`${firstname}-${x}`}
                        onClick={() => onSelect(passengers[x])}
                      >
                        {passengersMapList.map(({ key, title }, z) => (
                          <Flex className="justify-between" key={identifier}>
                            <Typography className="text-muted-foreground">
                              {title} :
                            </Typography>

                            <Typography className="text-foreground font-medium">
                              {/* @ts-ignore */}
                              {passengers[x][key as keyof Passenger[x]]}
                              {key === "firstname" && passengers[x].lastname}
                            </Typography>
                          </Flex>
                        ))}
                      </Flex>
                    </DialogClose>
                  ))}
              </Flex>
            ) : (
              <Typography variant="h6" className="font-medium">
                {noPassenger}
              </Typography>
            )}
          </Flex>
        </Flex>
      </DialogContent>
    </Dialog>
  );
}
